import React from "react";
import { Container, Row, Col, Card, CardHeader, Modal, ModalBody, ModalHeader, Button, Input, ListGroup, ListGroupItem, Label } from "@/Components/ui";
;
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { API_VOUCHER, API_VOUCHERS, API_VOUCHER_ALL, cancelVoucherItem, changeVoucherItem, deleteVoucherItem, getDataFromUrl } from "../../../api";
import { read, utils, writeFileXLSX, writeFile } from 'xlsx';
import QueryString from "qs";
import moment from "moment";
import UsageSection from "../../../Components/B2Busage";
import { dialogService } from "@/utils/dialogService";
const STATE_MODAL_FOCUS = {
    0: "사용처리",
    1: "사용취소",
};
const UserVoucherList = (props) => {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    // 10/23 대표 승인: "만료됨"은 기본 숨김, "만료 포함 보기"로 볼 수 있음
    const [showExpired, setShowExpired] = React.useState(false);
    const expiredQuery = React.useMemo(() => ({ hide_expired: showExpired ? "" : "1" }), [showExpired]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => { console.log(e); });
    };
    React.useEffect(() => {
        if (!previous && !next) {
            getDataFromUrl(`${API_VOUCHERS}/?hide_expired=1`)
                .then((data) => {
                // console.log(data);
                setData(data.results);
                setPrevious(data.previous);
                setNext(data.next);
                setCount(data.count);
            })
                .catch((e) => { console.log(e); });
        }
    }, []);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [stateChangeModal, setStateChangeModal] = React.useState(false);
    const [focusState, setFocusState] = React.useState(-1); // 0 : "사용처리", 1 : "사용취소"
    const [deleteModal, setDeleteModal] = React.useState(false);
    const togStateChangeModal = () => setStateChangeModal(!stateChangeModal);
    const togDeleteModal = () => setDeleteModal(!deleteModal);
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id}/>;
            },
            id: '#',
        },
        {
            Header: '번호',
            accessor: 'row_number',
            id: 'row_number',
        },
        {
            Header: 'ID',
            accessor: 'id',
            id: 'id',
        },
        {
            Header: '사용자',
            accessor: '사용자',
            id: 'user_id',
            Cell: (cellProps) => {
                // [B] 지시 17: 직원 테스트 계정이 받은 쿠폰(통계·정산 집계 제외)
                return (<>{cellProps.row.original["사용자"]}{cellProps.row.original["is_test"] ? <span className="badge bg-light text-secondary border ms-1">테스트</span> : null}</>);
            },
        },
        {
            Header: '교환권',
            accessor: '교환권',
            id: 'voucher',
        },
        {
            Header: '만료일',
            accessor: '만료일',
            id: 'expire_date',
        },
        {
            Header: '상태',
            accessor: '상태',
            id: 'state',
        },
        {
            Header: '사용일',
            accessor: '사용일',
            id: 'used_time',
            Cell: (cellProps) => {
                return (<>{cellProps.row.original["used_time"] ? moment(cellProps.row.original["used_time"]).format("yyyy-MM-DD HH:mm") : ""}</>);
            },
        },
        {
            Header: '선물',
            accessor: 'gifted',
            id: 'gifted',
            Cell: (cellProps) => {
                return (<>{cellProps.row.original["gifted"] ? cellProps.row.original["gifted"] : ""}</>);
            }
        },
        {
            Header: 'Actions',
            accessor: 'Actions',
            id: '',
            Cell: (cellProps) => {
                return (<div className="d-flex gap-2">
							{(moment(cellProps.row.original["만료일"]).isAfter(moment())) ? <>
								{(cellProps.row.original["상태"] !== "사용함") && <div className="edit">
									<div className="text" style={{ cursor: "pointer", color: "#3577f1" }} onClick={() => {
                                setCheckedRecords([cellProps.row.original]);
                                togStateChangeModal();
                                setFocusState(0);
                            }}>
										<i className="ri-pencil-fill fs-16"></i>
									</div>
								</div>}
								{(cellProps.row.original["상태"] !== "사용안함") && <div className="edit">
									<div className="text" style={{ cursor: "pointer", color: "#ffbe0b" }} onClick={() => {
                                setCheckedRecords([cellProps.row.original]);
                                togStateChangeModal();
                                setFocusState(1);
                            }}>
										<i className="ri-pencil-fill fs-16"></i>
									</div>
								</div>}
							</> : null}

							<div className="remove">
								<div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        setCheckedRecords([cellProps.row.original]);
                        togDeleteModal();
                    }}>
									<i className="ri-delete-bin-5-fill fs-16"></i>
								</div>
							</div>
						</div>);
            }
        },
    ], []);
    const clearSelectedOptions = () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        const checkall = document.getElementById("checkBoxAll");
        ele.forEach((element) => {
            element.checked = false;
        });
        checkall.checked = false;
        setFocusState(-1);
    };
    const deleteRecords = () => {
        (async () => {
            for (let i = 0; i < checkedRecords.length; i++) {
                const record = checkedRecords[i];
                await deleteVoucherItem(record.id);
            }
            await dialogService.handleAlert("삭제 완료");
        })().then(() => history.go(0)).catch((e) => console.log(e));
    };
    const changeState = () => {
        (async () => {
            if (focusState === 0) {
                // checkedRecords.forEach((record, idx, arr) => {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["상태"] === "사용안함") {
                        await changeVoucherItem(record.id);
                    }
                }
                await dialogService.handleAlert("사용처리 완료");
            }
            else if (focusState === 1) {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["상태"] === "사용함") {
                        await cancelVoucherItem(record.id);
                    }
                }
                await dialogService.handleAlert("사용취소 완료");
            }
        })().then(() => history.go(0)).catch((e) => console.log(e));
    };
    const changeCheckedRecords = () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        let checked = [];
        try {
            ele.forEach((element) => {
                let tmpArr = data.filter((item) => (item.id).toString() === element.value.toString());
                let obj = tmpArr[0];
                checked.push(obj);
            });
        }
        catch (error) {
            console.log(error);
        }
        // console.log("changeCheckedRecords", checked)
        setCheckedRecords(checked);
    };
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    return (<React.Fragment>
			<div className="page-content">
				<Container fluid>
					<BreadCrumb title="사용자교환권" pageTitle="교환권"/>
					<Row>
						<Col lg={12}>
							<Card id="customerList">
								<CardHeader className="border-0">
									<Row className="g-4 align-items-center">
										<div className="col-sm">
											<div>
												<h5 className="card-title mb-0">사용자 교환권 목록</h5>
											</div>
										</div>
										<div className="col-sm-auto">
											<div className="hstack gap-2">

												<Button onClick={async () => {
            await dialogService.handleAlert("액셀 파일을 다운로드합니다... 건수가 400건이 넘을 경우 파일에 누락될 수 있으니 유의하시기 바랍니다.");
            getDataFromUrl(`${API_VOUCHER_ALL}/?${QueryString.stringify(dataQuery)}`).then((data) => {
                const rows = data.map(row => ({
                    "번호": row.row_number,
                    "id": row.id,
                    "사용자": row["사용자"],
                    "교환권": row["교환권"],
                    "상태": row["상태"],
                    "만료일": row["만료일"]
                }));
                const worksheet = utils.json_to_sheet(rows);
                const workbook = utils.book_new();
                utils.book_append_sheet(workbook, worksheet, "번호");
                writeFileXLSX(workbook, "output.xlsx");
            });
        }} color="soft"><i className="ri-save-2-line"></i></Button>
												<span style={{ padding: "4px" }}></span>

												<Button onClick={() => { changeCheckedRecords(); togStateChangeModal(); setFocusState(0); }} color="soft-secondary" className="me-1">사용처리</Button>
												<Button onClick={() => { changeCheckedRecords(); togStateChangeModal(); setFocusState(1); }} color="soft-warning" className="me-1">사용취소</Button>
												<Button onClick={() => { changeCheckedRecords(); togDeleteModal(); }} color="soft-danger" className="me-1"><i className="ri-delete-bin-2-line"></i></Button>
											</div>
										</div>
									</Row>
								</CardHeader>


								<div className="card-body pt-0 px-2">
									<div>
										<React.Fragment>
											<div className="form-check form-switch mb-2">
                                                <input className="form-check-input" type="checkbox" id="show-expired-UserVoucherList" checked={showExpired}
                                                    onChange={(e) => { const v = e.target.checked; setShowExpired(v); onRequestData(`${API_VOUCHERS}/?hide_expired=${v ? "" : "1"}`); }} />
                                                <label className="form-check-label" htmlFor="show-expired-UserVoucherList">만료 포함 보기</label>
                                            </div>
                                            <ServerPaginatedTable tableQuery={expiredQuery} url={API_VOUCHERS} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[
            { id: 0, title: "전체", search: "", icon: "ri-store-2-fill" },
            { id: 1, title: "사용안함", search: "사용안함", icon: "ri-checkbox-circle-line" },
            { id: 2, title: "사용함", search: "사용함", icon: "ri-more-fill" },
            { id: 3, title: "수신안함", search: "수신안함", icon: "ri-arrow-left-right-fill" },
            { id: 4, title: "만료됨", search: "만료됨", icon: "ri-arrow-left-right-fill" },
        ]}/>
										</React.Fragment>
									</div>
									{/* <Toaster position="top-center" /> */}
								</div>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>


			{/* Modals */}

			{/* 교환권 상태 전환 Modal */}
			<Modal id="topmodal" isOpen={stateChangeModal} onClose={() => { clearSelectedOptions(); togStateChangeModal(); }}>
				<ModalHeader className="modal-title" id="myModalLabel" toggle={() => { clearSelectedOptions(); togStateChangeModal(); }}>
					{STATE_MODAL_FOCUS[focusState]}
				</ModalHeader>
				<ModalBody className="text-center p-5">
					<div className="mt-4">
						<h6 className="mb-3">{`선택하신 사용자의 교환권을 모두 ${STATE_MODAL_FOCUS[focusState]}하시겠습니까?`}</h6>
						<p className="text-muted mb-4">{(focusState === 0) ? '"사용안함"인 교환권만 "사용함"으로 변경됩니다.' : '"사용함"인 교환권만 "사용안함"으로 변경됩니다.'}</p>
						{(checkedRecords.length > 0) ?
            <div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
									<ListGroup>
										{checkedRecords.map((record) => {
                    return (<ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["사용자"]} - ${record["교환권"]}`}</ListGroupItem>);
                })}
									</ListGroup>
								</div> :
            <span>{`${STATE_MODAL_FOCUS[focusState]}할 사용자 교환권을 먼저 선택해주세요.`}</span>}
						<br />
						<br />
						<div className="hstack gap-2 justify-content-center">
							<button className={(focusState === 0) ? "btn btn-soft-secondary fw-medium" : "btn btn-soft-warning fw-medium"} onClick={() => { clearSelectedOptions(); togStateChangeModal(); }}><i className="ri-close-line me-1 align-middle"></i> Close</button>
							<button className={(focusState === 0) ? "btn btn-secondary" : "btn btn-warning"} onClick={() => { changeState(); setStateChangeModal(false); }} disabled={checkedRecords.length === 0}>{STATE_MODAL_FOCUS[focusState]}</button>
						</div>
					</div>
				</ModalBody>
			</Modal>

			{/* Delete Modal */}
			<Modal id="topmodal" isOpen={deleteModal} onClose={() => { clearSelectedOptions(); togDeleteModal(); }}>
				<ModalHeader className="modal-title" id="myModalLabel" toggle={() => { clearSelectedOptions(); togDeleteModal(); }}>
					삭제하기
				</ModalHeader>
				<ModalBody className="text-center p-5">
					<div className="mt-4">
						<h5 className="mb-3">선택하신 사용자의 교환권을 모두 삭제하시겠습니까?</h5>
						{/* <p className="text-muted mb-4"> The transfer was not successfully received by us. the email of the recipient wasn't correct.</p> */}
						{(checkedRecords.length > 0) ?
            <div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
									<ListGroup>
										{checkedRecords.map((record) => {
                    return (<ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["사용자"]} - ${record["교환권"]}`}</ListGroupItem>);
                })}
									</ListGroup>
								</div> :
            <span>삭제를 원하시는 사용자 교환권을 먼저 선택해주세요.</span>}
						<br />
						<br />
						<div className="hstack gap-2 justify-content-center">
							<Button onClick={() => { clearSelectedOptions(); togDeleteModal(); }} className="bg-gradient-light fw-medium"><i className="ri-close-line me-1 align-middle"></i> Close</Button>
							<Button onClick={() => { deleteRecords(); setDeleteModal(false); }} disabled={checkedRecords.length === 0} color="danger">Delete</Button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</React.Fragment>);
};
export default UserVoucherList;
